import { render, staticRenderFns } from "./Tekst2.vue?vue&type=template&id=24fb982b&scoped=true&"
import script from "./Tekst2.vue?vue&type=script&lang=js&"
export * from "./Tekst2.vue?vue&type=script&lang=js&"
import style0 from "./Tekst2.vue?vue&type=style&index=0&id=24fb982b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb982b",
  null
  
)

export default component.exports